module.exports = __webpack_public_path__ + "img/5836c792.png";